import React from 'react'
import GridedRow from '../GridedRow/GridedRow'
import {sortWith, descend, prop} from 'ramda'
import {
  dateRenderer,
  adminInfoRenderer,
} from './helpers'

const dateSort = sortWith([
  descend(prop('created_at')),
])

const ViewSupportTicket = ({ticket, currentUserId, displayAll}) => {

  const renderSingleSupportTicket = (ticket) => {
    const isOutgoingReply = currentUserId === ticket.user.id
    const className = isOutgoingReply? 'outgoing' : 'incoming'

    return <article key={ticket.created_at} className={className}>
      <header>
        {ticket.user.first_name + ' ' + ticket.user.last_name}:
      </header>
      <article dangerouslySetInnerHTML={{
        __html: ticket.text
      }} />
      {adminInfoRenderer(ticket.user.extra)}
      <footer>
        <time>{dateRenderer(ticket.created_at)}</time>
        {ticket.attachment && <aside>
          <a href={ticket.attachment} target="_blank">فایل ضمیمه</a>
        </aside>}
      </footer>
    </article>
  }

  return (
    <GridedRow columns={1} className='tickets'>
      {renderSingleSupportTicket(ticket)}
    </GridedRow>
  )
}

export default ViewSupportTicket


// WEBPACK FOOTER //
// ./src/components/common/Support/ViewSupportTicket.js